/**
 * This is just an example file and can be removed once real reducers are in place
 */

import {ReduxSlices} from "floorplan-v2/app/appRoot/types";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IResizeState} from "./types";
import { FloorplanV2State } from 'floorplan-v2/app/appRoot/rootReducer';
import { DESIGN_SCALE } from "floorplan-v2/app/components/Tables/Chair/types";

const initialState: IResizeState = {
  width: window.innerWidth,
  height: window.innerHeight,
  appScale: 0,
  isLoading: false,
  isZooming: false,
  rerender: true, // for trigger rerender or prevent rerender due to pattern change
}
export const initFloorplanWidth = createAsyncThunk(
  `${ReduxSlices.Resize}/initFloorplanWidth`,
  async (payload, { dispatch, getState }) => {
    const state = getState() as FloorplanV2State;
    const bookingCardListWidth = state.resizerReducer?.width || 300;
    return {width: window.innerWidth - bookingCardListWidth, height: window.innerHeight};
  });
const resizeSlice = createSlice({
  name: ReduxSlices.Resize,
  initialState,
  reducers: {
    changeSize: (state: IResizeState, action: PayloadAction<{width: number, height: number}>) => {
      state.width = action.payload.width;
      state.height = action.payload.height;
    },
    setWidth: (state: IResizeState, action: PayloadAction<number>) => {
      state.width = action.payload;
    },
    setAppScale: (state: IResizeState, action: PayloadAction<number>) => {
      state.appScale = action.payload;
      console.log('--------- CURRENT ZOOM LEVEL:' + (state.appScale * DESIGN_SCALE).toFixed(4));
    },
    setRerender: (state: IResizeState, action: PayloadAction<boolean>) => {
      state.rerender = action.payload;
    },
    setIsLoading: (state: IResizeState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsZooming: (state: IResizeState, action: PayloadAction<boolean>) => {
      state.isZooming = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initFloorplanWidth.fulfilled, (state, action) => {
      state.width = action.payload.width;
      state.height = action.payload.height;
    });
  }
})

// Extract the action creators object and the reducer
const { actions, reducer } = resizeSlice;
// Extract and export each action creator by name
export {actions as resizeActions};
// Export the reducer, either as a default or named export
export default reducer;
